/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { CourseCard, CourseCardProps } from "./CourseCard";
import { FilterBar,  IFilter } from "./FilterBar";
import { ICourse, IPaginateRequest } from "utils/types";

const DashboardContainer = styled.div`
  width: 100%;
  height: 100dvh;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  font-family: "Manrope", sans-serif;
  background: #f9fafb;
`;

const SectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 1.5rem 0;
`;

const CourseGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  margin-bottom: 3rem;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

const ContentWrapper = styled.div`
  padding: 32px 0;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #6b7280;
  font-size: 14px;
`;


export interface DashboardProps extends Pick<CourseCardProps, "onMoveToCourseDetail"> {
  onGetCourses: (data: {course?: Partial<ICourse>, search?: string; pagination: IPaginateRequest}) => Promise<ICourse[]>;
  onGetRecommendedCourses: (data: {pagination: IPaginateRequest}) => Promise<ICourse[]>;
}

export const Dashboard: React.FC<DashboardProps> = ({
  onGetCourses, onGetRecommendedCourses, onMoveToCourseDetail
}) => {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState<IPaginateRequest>({
    limit: 100, skip: 0
  })
  const [courses, setCourses] = useState<ICourse[]>([]);
  const [recommendedCourses, setRecommendedCourses] = useState<ICourse[]>([]);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState<IFilter>({
    courseType: "all",
    courseCategoryTab: "all"
  })
  

  useEffect(() => {
    const course:Partial<ICourse> = {};
    if (filter?.courseCategoryTab !== "all") {
      course.category = filter.courseCategoryTab;
    }
    if (filter.courseType !== "all") {
      course.courseType = filter.courseType;
    }
    setLoading(true)
    onGetCourses({course, search, pagination}).then((res) => {
      setCourses(res);
    }).finally(() => setLoading(false));
  }, [JSON.stringify(pagination), search, JSON.stringify(filter)]);
  useEffect(() => {
    onGetRecommendedCourses({pagination: {limit: 10, skip: 0}}).then(setRecommendedCourses);
  }, [])


  return (
    <DashboardContainer>
      <FilterBar {...{
        filter, onSetFilter: setFilter
      }}      />
      <ContentWrapper>
        {!loading && courses.length === 0 ? (
          <EmptyState>No courses found for the selected filters.</EmptyState>
        ) : (
          <>
            {recommendedCourses.length > 0 && (
              <>
                <SectionTitle>Recommended courses</SectionTitle>
                <CourseGrid>
                  {recommendedCourses.map((course, index) => (
                    <CourseCard key={index} {...{
                      course, onMoveToCourseDetail,
                    }} />
                  ))}
                </CourseGrid>
              </>
            )}

            {courses.length > 0 && (
              <>
                <SectionTitle>Specialized courses</SectionTitle>
                <CourseGrid>
                  {courses.map((course, index) => (
                    <CourseCard key={index} {...{
                      course, onMoveToCourseDetail
                    }}/>
                  ))}
                </CourseGrid>
              </>
            )}
          </>
        )}
      </ContentWrapper>
    </DashboardContainer>
  );
};
